import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { of } from 'rxjs';
import { mergeMap, map, catchError, withLatestFrom, filter } from 'rxjs/operators';
import * as UserProfileActions from '../actions/user-profile.actions';
import { AppState } from '../../app.state';
import { UserProfileService } from '../services/user-profile.service';

@Injectable()
export class UserProfileEffects {
  constructor(
    private actions$: Actions,
    private userProfileService: UserProfileService,
    private store: Store<AppState>
  ) { }

  loadEmailSignatureFromLoggedInUser$ = createEffect(() =>
    this.actions$.pipe(
      ofType(UserProfileActions.loadEmailSignatureFromLoggedInUser),
      withLatestFrom(this.store.select(state => state.main.signedInUserEmailSignature)),
      filter(([action, signedInUserEmailSignature]) => !signedInUserEmailSignature), // only continue if not loaded before
      mergeMap(([action]) => {
        const { organizationId } = action;
        return this.userProfileService.getCurrentUserProfile(organizationId).pipe(
          map(userProfile => UserProfileActions.loadEmailSignatureFromLoggedInUserSuccess({ emailSignature: userProfile.emailSignature || '' })),
          catchError(error => of(UserProfileActions.loadEmailSignatureFromLoggedInUserFailure({ error })))
        );
      })
    )
  );
}
